const cacheImages = async (
  srcArray: string[] | [string, string][],
): Promise<void> => {
  const promises = srcArray.map((src) => {
    return new Promise<void>((resolve, reject) => {
      if (typeof src === 'string') {
        const img = new Image();
        img.src = src;
        img.onload = (): void => resolve();
        img.onerror = (): void => reject();
      } else {
        const result = {
          first: false,
          second: false,
        };
        const firstImg = new Image();
        const secondImg = new Image();
        src.forEach((item, index) => {
          const img = index ? secondImg : firstImg;
          const label = index ? 'second' : 'first';
          img.src = item;
          img.onload = (): void => {
            result[label] = true;

            if (result.first && result.second) {
              resolve();
            }
          };
          img.onerror = (): void => reject();
        });
      }
    });
  });
  await Promise.all(promises);
};

export { cacheImages };
